'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
function cbFullscreenController($location, EventsService) {
    var vm = this;

    vm.isVisible = false;

    /* body is set to overflow:hidden to prevent body scrolling when fullscreen is open */
    vm.open = function () {
        vm.isVisible = true;
        document.body.style.overflow = 'hidden';
        EventsService.triggerResult('fullscreen.open', $location.path());
    };

    /* body overflow:hidden is removed to allow body scrolling when fullscreen is closed */
    vm.close = function () {
        vm.isVisible = false;
        document.body.style.removeProperty('overflow');
        EventsService.triggerResult('fullscreen.close', $location.path());
    };
}

cbFullscreenController.$inject = ['$location', 'EventsService'];

exports.default = cbFullscreenController;


//////////////////
// WEBPACK FOOTER
// ./src/lib/ui-components/fullscreen/cb-fullscreen.controller.js
// module id = 890
// module chunks = 0